"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyInsightMenuItem = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var alignPoints = [{ align: "cl cr" }];
exports.LegacyInsightMenuItem = function (_a) {
    var bubbleId = _a.bubbleId, className = _a.className, isDisabled = _a.isDisabled, onClick = _a.onClick, title = _a.title, _b = _a.bubbleMessage, bubbleMessage = _b === void 0 ? "" : _b;
    var itemClasses = classnames_1.default("gd-list-item", "gd-menu-item", className, { "is-disabled": isDisabled });
    if (isDisabled) {
        var button = react_1.default.createElement(sdk_ui_kit_1.Item, { className: itemClasses }, title);
        if (bubbleMessage) {
            return (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { className: "s-gd-bubble-trigger-options-menu-item" },
                button,
                react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary bubble-primary-" + bubbleId + " s-bubble-primary-" + bubbleId, alignPoints: alignPoints }, bubbleMessage)));
        }
        else {
            return button;
        }
    }
    else {
        return (react_1.default.createElement(sdk_ui_kit_1.Item, { className: itemClasses, onClick: onClick }, title));
    }
};
//# sourceMappingURL=LegacyInsightMenuItem.js.map